import {Select} from '@mantine/core'
import {useEffect, useMemo, useState} from 'react'

import {type CustomerDataLayer, customerDataLayer} from './customer-data-layer'
import type {Customer} from './types'

type JobsCustomerFilterProps = {
    value: string | null
    onChange: (customerId: string | null) => void
    dataLayer?: CustomerDataLayer
}

export function JobsCustomerFilter({
    value,
    onChange,
    dataLayer = customerDataLayer,
}: JobsCustomerFilterProps) {
    const [customers, setCustomers] = useState<Customer[]>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        let cancelled = false
        setIsLoading(true)

        void dataLayer.listCustomers().then((results) => {
            if (!cancelled) {
                setCustomers(results)
                setIsLoading(false)
            }
        })

        return () => {
            cancelled = true
        }
    }, [dataLayer])

    const options = useMemo(
        () => customers.map((customer) => ({value: customer.id, label: customer.name})),
        [customers],
    )

    return (
        <Select
            aria-label="Customer"
            placeholder={isLoading ? 'Loading customers...' : 'Customer'}
            searchable
            clearable
            disabled={isLoading}
            data={options}
            value={value}
            onChange={onChange}
            nothingFoundMessage="No customers found"
            w={170}
        />
    )
}
